// A key that is missing from the Contentful set used to be printed as-is, so
// the admin's edit dialog asked staff to fill in "field.date-of-birth".
const NAMED: {[key: string]: string} = {
  'field.departure-date': 'Departure Date',
  'field.return-date': 'Return Date',
  'field.overall-cost': 'Overall Cost',
  'field.first-name': 'First Name',
  'field.last-name': 'Last Name',
  'field.date-of-birth': 'Date of Birth',
  'field.email': 'Email Address',
};

const SMALL_WORDS = ['of', 'the', 'and', 'to', 'for', 'a', 'an'];

const titleCase = (words: string[]): string =>
  words
    .map((word, index) =>
      index > 0 && SMALL_WORDS.includes(word)
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(' ');

export const readableKey = (key: string): string => {
  if (NAMED[key]) return NAMED[key];

  // Hints and placeholders are optional; an invented one reads worse than none.
  if (/-(placeholder|helper|hint)$/.test(key)) return '';

  const [, ...rest] = key.split('.');
  const words = (rest.join(' ') || key).split(/[-_\s]+/).filter(Boolean);

  return words.length ? titleCase(words) : key;
};
